module.exports = __webpack_public_path__ + "static/03-53565c30af97cb024d02275c759170f4.jpg";